/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Cash_CardInputs */

const en_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices shown as cash / card`)
};

const es_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios mostrados como efectivo / tarjeta`)
};

const de_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise jeweils bar / mit Karte`)
};

const zh_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格显示为现金/卡`)
};

const ar_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسعار معروضة نقداً / ببطاقة`)
};

const fr_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix affichés en espèces / carte`)
};

const vi_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá hiển thị theo tiền mặt / thẻ`)
};

const sw_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei zinaonyeshwa kwa pesa taslimu / kadi`)
};

const th_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคาที่แสดงเป็นเงินสด/บัตร`)
};

const bs_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cijene prikazane kao gotovina / kartica`)
};

const ja_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示価格：現金／カード`)
};

const ko_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현금 / 카드로 표시된 가격`)
};

const pt_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços em dinheiro / cartão`)
};

const it_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi indicati come contanti / carta`)
};

const sv_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priserna visas som kontant / kort`)
};

const nl_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijzen weergegeven als contant / kaart`)
};

const da_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priserne er vist som kontant / kort`)
};

const nb_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisene er oppgitt som kontant / kort`)
};

const fi_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinnat käteisellä / kortilla`)
};

const pl_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny podane za gotówkę / kartę`)
};

const ru_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены указаны за наличные / по карте`)
};

const tr_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyatlar nakit / kart içindir`)
};

const hi_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल्य नकद / कार्ड के रूप में दिखाया गया`)
};

const id_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga ditampilkan untuk tunai / kartu`)
};

const ms_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga ditunjukkan sebagai tunai / kad`)
};

const cs_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny jsou uvedeny za hotovost / kartu`)
};

const el_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Οι τιμές εμφανίζονται για μετρητά / κάρτα`)
};

const he_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המחירים מוצגים במזומן / בכרטיס`)
};

const af_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pryse getoon as kontant / kaart`)
};

const hu_prices_cash_card = /** @type {(inputs: Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az árak készpénzes / kártyás fizetésre vonatkoznak`)
};

/**
* | output |
* | --- |
* | "Prices shown as cash / card" |
*
* @param {Prices_Cash_CardInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_cash_card = /** @type {((inputs?: Prices_Cash_CardInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Cash_CardInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_cash_card(inputs)
	if (locale === "de") return de_prices_cash_card(inputs)
	if (locale === "zh") return zh_prices_cash_card(inputs)
	if (locale === "ar") return ar_prices_cash_card(inputs)
	if (locale === "fr") return fr_prices_cash_card(inputs)
	if (locale === "vi") return vi_prices_cash_card(inputs)
	if (locale === "sw") return sw_prices_cash_card(inputs)
	if (locale === "th") return th_prices_cash_card(inputs)
	if (locale === "bs") return bs_prices_cash_card(inputs)
	if (locale === "ja") return ja_prices_cash_card(inputs)
	if (locale === "ko") return ko_prices_cash_card(inputs)
	if (locale === "pt") return pt_prices_cash_card(inputs)
	if (locale === "it") return it_prices_cash_card(inputs)
	if (locale === "sv") return sv_prices_cash_card(inputs)
	if (locale === "nl") return nl_prices_cash_card(inputs)
	if (locale === "da") return da_prices_cash_card(inputs)
	if (locale === "nb") return nb_prices_cash_card(inputs)
	if (locale === "fi") return fi_prices_cash_card(inputs)
	if (locale === "pl") return pl_prices_cash_card(inputs)
	if (locale === "ru") return ru_prices_cash_card(inputs)
	if (locale === "tr") return tr_prices_cash_card(inputs)
	if (locale === "hi") return hi_prices_cash_card(inputs)
	if (locale === "id") return id_prices_cash_card(inputs)
	if (locale === "ms") return ms_prices_cash_card(inputs)
	if (locale === "cs") return cs_prices_cash_card(inputs)
	if (locale === "el") return el_prices_cash_card(inputs)
	if (locale === "he") return he_prices_cash_card(inputs)
	if (locale === "af") return af_prices_cash_card(inputs)
	if (locale === "hu") return hu_prices_cash_card(inputs)
	return en_prices_cash_card(inputs)
});